import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {ReelsCascadingModule, ReelsCascadingMoveData, ReelsCascadingStates, ReelsCascadingView} from '@gongxigames/framework/slot/modules/reelsCascading';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {ReelConstants} from '@gongxigames/framework/slot/utils';

export class ReelsCascadingReleaseSymbolsState extends ModuleState<ReelsCascadingView, ReelsCascadingModule> {
    protected spinResolve: (() => void) | undefined;

    public async onEnterState(): Promise<void> {
        this.module.resetParameters();
        this.module.eventManager.emit('General.UI.DISABLE', ReelsCascadingModule.NAME);
        this.module.eventManager.emit(ReelsEvents.REELS_SPINNING_STARTED);
        await Promise.all([
            this.moveAllSymbols(),
            this.waitForSpinResponse()
        ]);
        this.goToFillInState();
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(LogicEvents.SPIN_RESPONSE, this.onSpinResponseReceived.bind(this));
        this.setEventHandler(LogicEvents.FREE_SPIN_RESPONSE, this.onSpinResponseReceived.bind(this));
        this.setEventHandler(LogicEvents.RESPIN_RESPONSE, this.onSpinResponseReceived.bind(this));
        this.setEventHandler(LogicEvents.MINI_SPIN_RESPONSE, this.onSpinResponseReceived.bind(this));
    }

    protected onSpinResponseReceived(): void {
        this.spinResolve && this.spinResolve();
    }

    protected waitForSpinResponse(): Promise<void> {
        return new Promise(resolve => {
            this.spinResolve = resolve;
        });
    }

    protected async moveAllSymbols(): Promise<void> {
        const rowAmount = ReelConstants.ROW_AMOUNT;
        const reels = this.module.reels;
        const promises: Promise<void>[] = [];

        reels.forEach((reel, reelIndex) => {
            for (let i = 0; i < rowAmount; i++) {
                promises.push(this.moveSymbol(reelIndex, i));
            }
        });

        await Promise.all(promises);
    }

    protected async moveSymbol(reelIndex: number, symbolIndex: number): Promise<void> {
        const rowAmount = ReelConstants.ROW_AMOUNT;
        const {betweenReelsDelay, betweenReelsDelayTurbo, betweenSymbolsDelay, betweenSymbolsDelayTurbo, distanceInSymbolsToReleaseMove} = this.module.reelsCascadingConfig;
        const [betweenReelsDelayValue, betweenSymbolsDelayValue] = this.module.isTurboSpin()
            ? [betweenReelsDelayTurbo, betweenSymbolsDelayTurbo]
            : [betweenReelsDelay, betweenSymbolsDelay];
        const moveData: ReelsCascadingMoveData = {
            delay: betweenReelsDelayValue * reelIndex + betweenSymbolsDelayValue * (rowAmount - 1 - symbolIndex),
            fromCoordinates: {x: reelIndex, y: symbolIndex},
            toCoordinates: {x: reelIndex, y: symbolIndex + distanceInSymbolsToReleaseMove}
        };

        await this.view.moveSymbol(moveData);
        this.view.removeSymbolByPosition(moveData.toCoordinates);
    }

    protected goToFillInState(): void {
        this.module.gotoState(ReelsCascadingStates.FILL_IN_STATE);
    }
}